/**
 * Chart palette. These are the only colors the dashboard charts may use.
 *
 * BRAND + BRAND_DARK are the two categorical slots and were validated together
 * against the light surface: they clear the lightness band, the chroma floor,
 * CVD separation (ΔE 16.3 deutan / 16.8 tritan) and the normal-vision floor
 * (ΔE 16.6). Do not swap in a nearer shade — the obvious neighbours failed
 * either the chroma floor or the normal-vision floor.
 *
 * BRAND sits below 3:1 against the surface, so every chart using it also
 * carries visible labels (axis ticks, direct labels, or a hero number).
 */
export const BRAND = "#00C2CB";
export const BRAND_DARK = "#00899B";

/** Recessive gray for "no data yet" marks. Never used to encode a value. */
export const MUTED_MARK = "#E3E7EA";

/**
 * The two brand tints the empty conversion disc is drawn in — a shape where a
 * pie will go, not a pie. Like MUTED_MARK they never encode a value, so they
 * are exempt from the categorical pair's separation floors: nothing is being
 * told apart, and the counts beside them are written out in full.
 */
export const EMPTY_DISC_LIGHT = "#E3F7F9";
export const EMPTY_DISC = "#CBEFF4";

export const AXIS_TICK = "#9AA4AE";
